import { Flex, Icon, Radio, RadioProps, Space, Spacing, Text, Tooltip } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

interface SyncTimePeriodModeRadioProps extends RadioProps {
  header: string
  subheader: string
  tooltipLabel: ReactNode
}

export const SyncTimePeriodModeRadio = ({
  header,
  subheader,
  tooltipLabel,
  ...radioProps
}: SyncTimePeriodModeRadioProps): ReactElement => (
  <Radio {...radioProps}>
    <Text weight="bold">{header}</Text>
    <Flex alignItems="center" gap={Spacing.S4}>
      <Text variant="bodySM" colorVariant="secondary">
        {subheader}
      </Text>
      <Tooltip label={tooltipLabel} placement="top">
        <Icon icon="info" size="xs" />
        <Space size="s2" />
      </Tooltip>
    </Flex>
  </Radio>
)
